module.exports = __webpack_public_path__ + "img/home2.e038e183.png";